__turbopack_context__.v({
  "centered": "Modal-module-scss-module__wyQM2q__centered",
  "content": "Modal-module-scss-module__wyQM2q__content",
  "content-show": "Modal-module-scss-module__wyQM2q__content-show",
  "overlay": "Modal-module-scss-module__wyQM2q__overlay",
  "overlay-show": "Modal-module-scss-module__wyQM2q__overlay-show",
  "visually-hidden": "Modal-module-scss-module__wyQM2q__visually-hidden",
});
